import * as React from "react";
import { Link, Typography } from "@mui/material";
import LegalDocumentPage from "./LegalDocumentPage";

export default function TermsOfUse() {
  return (
    <LegalDocumentPage title="Terms of Use" lastUpdated="26 August 2026">
      <Typography>
        The SEEDS platform is provided as part of the <strong>SEEDS PRIMA
        research project (Grant Agreement No. 2332)</strong> for agricultural
        research, monitoring and collaboration.
      </Typography>

      <Typography>
        By using SEEDS, you agree to use the platform lawfully and for its
        intended purposes. You are responsible for the accuracy and
        appropriateness of the information, comments, images and other content
        you submit and must not upload unlawful, harmful or unauthorised
        material.
      </Typography>

      <Typography>
        Information, measurements, analyses and recommendations provided
        through SEEDS are intended for <strong>research and informational
        purposes</strong> and should not be considered a substitute for
        professional agricultural or other specialist advice.
      </Typography>

      <Typography>
        CERTH and the SEEDS project partners aim to maintain the availability
        and accuracy of the platform but cannot guarantee uninterrupted
        operation or the completeness or accuracy of all information,
        particularly data originating from users, sensors or external sources.
      </Typography>

      <Typography>
        Access may be restricted or suspended in cases of misuse, security risks
        or violation of these Terms.
      </Typography>

      <Typography>
        These Terms may be updated when necessary. Continued use of the platform
        after an update constitutes acceptance of the revised Terms.
      </Typography>

      <Typography>
        <strong>Contact:</strong>{" "}
        <Link href="mailto:laz@iti.gr">laz@iti.gr</Link>
      </Typography>
    </LegalDocumentPage>
  );
}
